import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue'
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/', redirect: { name: 'dashboard' } },
    ...apps,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    {
      //path: '*',
      path: '/:pathMatch(.*)*',
      redirect: 'error-404',
    },
  ],
  async scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (!to.hash) return { top: 0, left: 0 }

    await nextTick()
    // The route can resolve before its asynchronously loaded layout is mounted.
    // Resolve an ID directly so malformed hashes never become CSS selectors.
    const findTarget = () => document.getElementById(to.hash.slice(1))
    const target = findTarget() || await new Promise(resolve => {
      const finish = element => {
        observer.disconnect()
        clearTimeout(timeoutId)
        resolve(element)
      }
      const observer = new MutationObserver(() => {
        const element = findTarget()
        if (element) finish(element)
      })
      const timeoutId = setTimeout(() => finish(null), 3000)
      observer.observe(document.body, { childList: true, subtree: true })
    })

    if (router.currentRoute.value.fullPath !== to.fullPath) return false
    if (target) return { el: target, top: 16 }
    return { top: 0, left: 0 }
  },
})

router.beforeEach(to => {
  if (to.meta.credentialPage && typeof window !== 'undefined'
    && (window.__yournutriCredentialDocument !== true
      || window.__yournutriGtmLoaded || window.__yournutriGaLoaded || window.__yournutriMetaPixelLoaded)) {
    window.location.replace(to.fullPath)
    return false
  }
  const isLoggedIn = isUserLoggedIn()

  if (to.meta.public) return undefined

  if (!canNavigate(to)) {

    // Redirect to login if not logged in
    if (!isLoggedIn) return { name: 'auth-login' }

    // If logged in => not authorized
    return { name: 'misc-not-authorized' }
  }else{
    if (to.name == 'auth-agenda' && !to.meta.redirectIfLoggedIn) return undefined
    if (!to.meta.redirectIfLoggedIn && !isLoggedIn) return { name: 'auth-login' }
  }

  // Redirect if logged in Get Invoice
  if (to.meta.redirectIfLoggedInGetInvoice && isLoggedIn) {
    return { name: 'logged-get-invoice', params: {token: to.params.token} }
  }

  // Redirect if logged in Verify Email
  if(to.meta.redirectIfLoggedInVerifyEmail && isLoggedIn) {
    return { name: 'logged-verify-email', params: {token: to.params.token} }
  }

  // Redirect if logged in Share Feedback Client
  if(to.meta.redirectIfLoggedInFeedbackClient && isLoggedIn) {
    return { name: 'logged-feedback-client-meeting', params: {id: to.params.id} }
  }

  // Redirect if logged in Share Anamnesis
  if(to.meta.redirectIfLoggedInAnamnesisShare && isLoggedIn) {
    return { name: 'logged-anamnesis-share', params: {token: to.params.token} }
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return getHomeRouteForLoggedInUser(userData ? userData.role : null)
  }

  return undefined
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
